module.exports = __webpack_public_path__ + "assets/img/首页小图-智骑宝.a6c8daef.jpg";